import type { PositionExtended } from '@/types/domain/core';

export const groupPositions = (rawPositions: PositionExtended[]) => {
    const positions = rawPositions.map((pos) => {
        const splitPos = pos.name.split('_');
        const mainPosition = splitPos.length === 2 ? splitPos[1] : splitPos[2];

        return {
            ...pos,
            mainPosition
        };
    });

    const grouped: Record<string, PositionExtended[]> = {};

    positions.forEach((pos) => {
        if (!grouped[pos.mainPosition]) {
            grouped[pos.mainPosition] = [];
        }
        grouped[pos.mainPosition].push(pos);
    });

    return Object.entries(grouped).map(([main, posGroup]) => {
        const isActive = posGroup.some(p => p.active);
        const mainPos = posGroup.find(p => p.name.includes(main)) || posGroup[0];

        return {
            ...mainPos,
            name: main,
            active: isActive
        };
    });
};
